// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--m6DkR";
export var divider = "blog-module--divider--1kEX9";